import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=3f2b04e6&"
import script from "../../../services/admin/company/company-list.js?vue&type=script&lang=js&"
export * from "../../../services/admin/company/company-list.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports